import { useCallback } from 'react';
import { CampaignCreateOptionsSearchParams, useGetCampaignCreateOptionsApi } from '../api';

/**
 * Service for loading unified campaign start options (configs + presets).
 */
export const useCampaignCreateOptionsService = () => {
  const getCampaignCreateOptionsApi = useGetCampaignCreateOptionsApi();

  const getCampaignCreateOptions = useCallback(
    async (params: CampaignCreateOptionsSearchParams) => {
      const response = await getCampaignCreateOptionsApi(params);
      return response.data;
    },
    [getCampaignCreateOptionsApi],
  );

  return { getCampaignCreateOptions };
};
